// Angular
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
// Service
import { ViewsService } from '../../../../../../../services/views.service';
import { CVfUtilsService } from '../../../../../../services/cvf-utils.service';
// Model
import { SCHEMA_TYPE } from '../../../../../../../models/enums.model';
import { SmartTagTemplateForm } from '../../model/smart-tag-template-form.model';
import { SmartTagFormControlModel, SmartTagFormControlOutputType, SmartTagFormControlType } from '../../model/smart-tag-form-control.model';
import { SmartTagFormRenderEngineModel } from '../../model/smart-tag-render-form-engine.model';

@Component({
	selector: 'cv-schema-form-render',
	templateUrl: './form-render.component.html',
})
export class FormRenderComponent extends SmartTagTemplateForm implements OnInit, OnChanges {

	@Input() smartTagModel: SmartTagFormRenderEngineModel = null;
	@Input() selectedSmartTagItem: any = null;
	@Input() editMode: boolean;
	@Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

	public orderSchema = '';

	get schemaShouldShowComplexForm(): boolean {
		let response = false;
		const schemasShouldShow = [
			SCHEMA_TYPE.CVDS_40.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_1.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_11.toString()
		];

		response = schemasShouldShow.indexOf(this.orderSchema) > -1

		return response
	}

	private formSubscription: Subscription;

	constructor(
		private viewsService: ViewsService,
		protected cvfUtils: CVfUtilsService
	) {
		super(cvfUtils);
		this.editMode = false;
	}

	ngOnInit() {

		this.orderSchema = this.viewsService.order.schema;

		// Basic Form
		this.innerForm = new FormGroup({
			description: new FormControl(this.smartTagModel.description)
		});

		this.setFormValues();
		this.modeEdition = this.editMode;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['selectedSmartTagItem'] && !changes['selectedSmartTagItem'].firstChange) {

			this.formSubscription.unsubscribe();
			const prevSelectedSTItem = changes['selectedSmartTagItem'].previousValue;
			const oldFormControls = this.cvfUtils.getSelectedFormControls(prevSelectedSTItem);
			const oldformValues = this.innerForm.value;

			oldFormControls.forEach((formControl: SmartTagFormControlModel) => {
				if (formControl.field in oldformValues) {
					this.innerForm.removeControl(formControl.field);
				}
			});

			this.setFormValues();
		}
	}

	/**
	 * Set the smart tag fom values
	 * ToDo: refactor to movit innto the abstract class
	 */
	public setFormValues(): void {
		// Review if the selected Smart Tag Contain Form Controls
		this.prepareDynamicSmartTagFormControls(this.selectedSmartTagItem);

		switch (this.orderSchema) {
			case SCHEMA_TYPE.CVDS_40:
			case SCHEMA_TYPE.INSPECTIONLESS_1:
			case SCHEMA_TYPE.INSPECTIONLESS_11:

				this.formControl.forEach((formControl: SmartTagFormControlModel) => {
					if ('uiControl' in formControl) {
						switch(formControl.uiControl) {
							case 'Single':
								formControl.control = SmartTagFormControlType.SINGLE;
								formControl.outputType = SmartTagFormControlOutputType.ARRAY;
								break;
						}
					}

					this.addDynamicFormControl(formControl, this.smartTagModel);
				});

				break;
		}

		// Everytime the Form Change
		this.formSubscription = this.innerForm.valueChanges.subscribe(() => this.onValuesChange());
	}

	/**
	 * Emit values and status of this Form, for inner components and library too
	 * @private
	 */
	public onValuesChange(): void {
		const formValue = this.processOutputObject(this.smartTagModel);
		this.valueChange.next({ valid: this.innerForm.valid, value: formValue });
	}

}
